import ActionTypes from './types';

const getWorkouts = (workoutType) => ({
  type: ActionTypes.GET_WORKOUTS_REQUEST,
  payload: { workoutType },
});

const getWorkout = (workoutName) => ({
  type: ActionTypes.GET_WORKOUT_REQUEST,
  payload: { workoutName },
});

const getExercises = (workoutName) => ({
  type: ActionTypes.GET_EXERCISES_REQUEST,
  payload: { workoutName },
});

const resetStatus = () => ({
  type: ActionTypes.RESET_STATUS,
});

const trainingActions = {
  getWorkouts,
  getWorkout,
  getExercises,
  resetStatus,
};

export default trainingActions;
